var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumeMute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.92356 4.94096C11.0899 3.93409 12.8998 4.76267 12.8998 6.3035V17.0953C12.8998 18.6362 11.0898 19.4648 9.9235 18.4578L6.26501 15.2993H4.79976C3.80565 15.2993 2.99976 14.4934 2.99976 13.4993V9.89927C2.99976 8.90515 3.80565 8.09926 4.79976 8.09926H6.26504L9.92356 4.94096ZM15.8632 9.26335C16.2147 8.91188 16.7845 8.91188 17.136 9.26335L18.2996 10.427L19.4632 9.26335C19.8147 8.91188 20.3846 8.91188 20.736 9.26335C21.0875 9.61482 21.0875 10.1847 20.736 10.5361L19.5724 11.6998L20.736 12.8634C21.0875 13.2148 21.0875 13.7847 20.736 14.1362C20.3846 14.4876 19.8147 14.4876 19.4632 14.1362L18.2996 12.9726L17.136 14.1362C16.7845 14.4876 16.2147 14.4876 15.8632 14.1362C15.5117 13.7847 15.5117 13.2148 15.8632 12.8634L17.0268 11.6998L15.8632 10.5361C15.5117 10.1847 15.5117 9.61482 15.8632 9.26335Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMute);
export default __webpack_public_path__ + "static/media/volume-mute.fb68780d0ab6426cb9d162d9ce91e0be.svg";
export { ForwardRef as ReactComponent };